import React, { Component } from "react";
import { Form, Button, Container, Grid, Label } from "semantic-ui-react";
import "./main.css";

// main Form field to submit meme
export default class FormField extends Component {
    state = {
        caption: "",
        url: "",
        captionErr: "",
        urlErr: "",
        dbErr: "",
    };

    // validation checks on form fields
    validate = () => {
        let captionErr = "";
        let urlErr = "";
        if (this.state.caption.length < 3) {
            captionErr = "1";
            this.setState({ captionErr });
            return false;
        }
        this.setState({ captionErr: "" });
        if (
            !this.state.url.includes(".jpg") &&
            !this.state.url.includes("image") &&
            !this.state.url.includes(".jpeg") &&
            !this.state.url.includes(".png") &&
            !this.state.url.includes("https") &&
            !this.state.url.includes("http")
        ) {
            urlErr = "1";
            this.setState({ urlErr });
            return false;
        }
        return true;
    };

    handleSubmit = (event) => {
        event.preventDefault();

        const isValid = this.validate();
        if (isValid) {
            this.props.createMeme(this.state.caption, this.state.url);
            this.setState({ caption: "", url: "" });
            this.setState({ captionErr: "", urlErr: "" });
        }
    };

    // standard state changes handling

    handleCaptionChange = (event) => {
        this.setState({ caption: event.target.value });
    };

    handleURLChange = (event) => {
        this.setState({ url: event.target.value });
    };

    render() {
        // checking for errors from above validation checks
        let captionLabel = "";
        let urlLabel = "";
        if (this.state.captionErr !== "") {
            captionLabel = (
                <Label basic color="red" pointing="bottom">
                    Caption should be 3 chars atleast
                </Label>
            );
        }
        if (this.state.urlErr !== "") {
            urlLabel = (
                <Label basic color="red" pointing="bottom">
                    Please enter a valid url
                </Label>
            );
        }
        if (this.state.dbErr !== "") {
            urlLabel = (
                <Label basic color="red" pointing="bottom">
                    Meme already exists
                </Label>
            );
        }
        return (
            <Container className="form">
                <Form onSubmit={this.handleSubmit}>
                    <Grid>
                        <Grid.Row centered>
                            <Grid.Column width={8}>
                                <Form.Field>
                                    <Label content="Caption" />
                                    <input
                                        value={this.state.caption}
                                        className="inputField"
                                        placeholder="Enter a caption for meme"
                                        onChange={this.handleCaptionChange}
                                    />
                                    {captionLabel}
                                </Form.Field>
                                <Form.Field>
                                    <Label content="URL" />
                                    <input
                                        value={this.state.url}
                                        className="inputField"
                                        placeholder="Enter URL of the meme"
                                        onChange={this.handleURLChange}
                                    />
                                    {urlLabel}
                                </Form.Field>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row centered>
                            <Button type="submit" primary>
                                Submit New Meme
                            </Button>
                        </Grid.Row>
                    </Grid>
                </Form>
            </Container>
        );
    }
}
